import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IMenuItem } from '@core/interfaces/imenu-item';
import { AuthService } from '@core/services/auth.service';
import { MenuItemService } from '@core/services/menu-item.service';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavBarComponent implements OnInit {
  menuItems!: IMenuItem[];
  isLoggedIn: boolean = false;
  constructor(
    private router: Router, 
    private menuItem: MenuItemService, 
    private auth: AuthService,
    private toast: ToastrService) {
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit(): void {
    this.menuItem.getAll().pipe(take(1)).subscribe((res: any) => {
      this.menuItems = res;
    })

    this.isLoggedIn = this.auth.isLoggedIn();
  }

  handleSignInOut(): void {
    if (this.auth.isLoggedIn()) {
      this.auth.logout();
    } else {
      this.router.navigateByUrl('/login');
    }
  }
}
